module.exports = __webpack_public_path__ + "img/layout-6_3.354f97f6.png";